import { useQuery } from '@tanstack/react-query';
import { fetchAnalysisItems } from '@services/analysisItems';

export function useAnalysisItems(studyId) {
  console.log('[useAnalysisItems] invoked with studyId:', studyId);
  return useQuery({
    queryKey: ['analysisItems', studyId],
    queryFn: () => fetchAnalysisItems(studyId),

    enabled: !!studyId,
  });
}
